export const NEW_AGE_RANGE_MIN_13 = {
  min: 13,
  max: 99,
  value: '13 - 99',
  label: '13 - 99',
};
export const NEW_AGE_RANGE_MIN_16 = {
  min: 16,
  max: 99,
  value: '16 - 99',
  label: '16 - 99',
};
export const NEW_AGE_RANGE_MIN_18 = {
  min: 18,
  max: 99,
  value: '18 - 99',
  label: '18 - 99',
};
export const AGE_LIMITS_MIN_13 = { MIN: 13, MAX: 99 };
export const AGE_LIMITS_MIN_16 = { MIN: 16, MAX: 99 };
export const AGE_LIMITS_MIN_18 = { MIN: 18, MAX: 99 };
export const AGE_RANGE_MIN_DIFFERENCE_CONSTRAINT = 1;
export const COUNTRY_IDS_WITH_MIN_AGE_13 = [];
